import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Helmet } from 'react-helmet'

import { useGetPulseSurveyCollectorInfo } from 'hooks/pulseSurveys/useGetPulseSurveyCollectorInfo'
import { GetPulseSurveyCollectorInfoResponse } from 'api/actions/pulseSurveys/pulseSurveysActions.types'
import diversioLogo from 'assets/images/diversio-logo-with-symbol-for-light-bg.svg'

import { Loader } from './Loader'
import * as S from './pulseSurveysRespondents.styles'

export const PulseSurveysRespondents = () => {
    const [result, setResult] = useState<GetPulseSurveyCollectorInfoResponse | null>(null)

    const { id: surveyUUID } = useParams<{ id: string }>()

    const { mutate, isLoading, isError, error } = useGetPulseSurveyCollectorInfo()

    useEffect(() => {
        if (surveyUUID) {
            mutate(
                { surveyUUID },
                {
                    onSuccess: (data) => {
                        setResult(data)
                    },
                },
            )
        }
    }, [surveyUUID, mutate])

    if (isLoading) {
        return (
            <S.Container>
                <Loader />
            </S.Container>
        )
    }

    if (isError) {
        return (
            <S.Container>
                <S.Info>
                    <S.Title>Error</S.Title>

                    <S.Description>{error?.response?.data.detail || 'Something went wrong'}</S.Description>
                </S.Info>
            </S.Container>
        )
    }

    if (!result) {
        return (
            <S.Container>
                <Loader />
            </S.Container>
        )
    }

    const { status, survey_url: surveyUrl, title, detail } = result

    if (status === 'open' && surveyUrl) {
        window.location.href = surveyUrl

        return (
            <S.Container>
                <Helmet>
                    <meta property="og:title" content={title} />
                    <meta property="og:image" content={`${window.location.origin}${diversioLogo}`} />
                    <meta property="og:type" content="website" />
                </Helmet>

                <Loader />
            </S.Container>
        )
    }

    if (status === 'closed') {
        return (
            <S.Container>
                <Helmet>
                    <meta property="og:title" content={title} />
                    <meta property="og:image" content={`${window.location.origin}${diversioLogo}`} />
                    <meta property="og:type" content="website" />
                </Helmet>

                <S.Info>
                    <S.Title>{title}</S.Title>

                    <S.Description>{detail || 'Survey is closed'}</S.Description>
                </S.Info>

                <img src={diversioLogo} alt="Diversio" />
            </S.Container>
        )
    }

    return <></>
}
